import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "../axios/axios";
import { jobLoadAction } from "../redux/actions/jobAction";
import { Link, useParams } from "react-router-dom";
import { countries } from "../data/countries";
import jobLogo1 from "../images/job_logo_1.jpg";
import Footer from "../component/Footer";

function JobListing() {
  const [Jobs, setJobs] = useState([]);
  const { loading, jobs } = useSelector((state) => state.loadJobs);
  const [filter, setFilter] = useState({
    position: "",
    jobType: "",
  });
  const [currentPage, setCurrentPage] = useState(1);

  const jobsPerPage = 7;
  const totalPages = Math.ceil(jobs?.length / jobsPerPage);
  const pageNumbers = [];

  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const handleClick = (pageNumber) => {
    // setCurrentPage(pageNumber);
  };
  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const { keyword, location } = useParams();

  const [cat, setCat] = React.useState("");
  useEffect(() => {
    window.scroll(0, 0);
    setTimeout(() => {
      dispatch(jobLoadAction(page, keyword, cat, location));
      setJobs(jobs);
    }, 1000);
  }, [page, keyword, cat, location]);

  const handleChangeCategory = (e) => {
    setCat(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = await axios.post("/api/jobs/filter", filter);
      console.log(data.data);
      setJobs(data.data);
    } catch (error) {
      console.log(error);
    }
    console.log(filter);
  };
  return (
    <>
      <section
        class="section-hero home-section overlay"
        style={{ backgroundColor: "grey", height: "300px" }}
        id="home-section"
      >
        <div class="container">
          <div class="row align-items-center justify-content-center">
            <div class="col-md-12">
              <div class="mb-5 text-center">
                <h1 class="text-white font-weight-bold">
                  The Easiest Way To Get Your Dream Job
                </h1>
                <p>
                  There is no shortcut to getting your dream job, but by
                  acquiring relevant skills, networking, <br /> and persistence,
                  you can increase your chances of achieving it.
                </p>
              </div>
              <form
                onSubmit={handleSubmit}
              >
                <div className=" mb-5" style={{
                  display:'flex',
                  justifyContent:'center',
                  alignItems:'center',
                }}>
                  <div className="">
                    <input
                      type="text"
                      className="form-control form-control-lg"
                      style={{
                        width: "700px",
                      }}
                      placeholder="Search here..."
                      onChange={(e) =>
                        setFilter({ ...filter, position: e.target.value })
                      }
                    />
                  </div>
                  {/* <div className="col-12 col-sm-6 col-md-6 col-lg-3 mb-4 mb-lg-0">
                    <select
                      class="selectpicker"
                      data-style="btn-white btn-lg"
                      data-width="100%"
                      data-live-search="true"
                      title="Select Region"
                    >
                      {countries.map((country) => (
                        <option key={country[1]} value={country[0]}>
                          {country[0]}
                        </option>
                      ))}
                    </select>
                  </div> */}
                  {/* <div className="col-12 col-sm-6 col-md-6 col-lg-3 mb-4 mb-lg-0">
                    <select
                      class="selectpicker"
                      data-style="btn-white btn-lg"
                      data-width="100%"
                      data-live-search="true"
                      title="Select Job Type"
                      onChange={(e) =>
                        setFilter({ ...filter, jobType: e.target.value })
                      }
                    >
                      <option value="part-time">Part Time</option>
                      <option value="full-time">Full Time</option>
                      <option value="remote">Remote</option>
                      <option value="internship">Internship</option>
                    </select>
                  </div> */}
                  <div className="col-12 col-sm-6 col-md-6 col-lg-3 mb-4 mb-lg-0">
                    <button
                      type="submit"
                      className="btn btn-lg btn-block text-white btn-search"
                      style={{
                        backgroundColor: "#1d4ed8",

                      }}
                    >
                      <span className="icon-search icon mr-2"></span>Search Job
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>

      <section class="site-section" id="next">
        <div class="container">
          <div class="row mb-5 justify-content-center">
            <div class="col-md-7 text-center">
              <h2 class="section-title mb-2">{jobs?.length}</h2>
            </div>
          </div>

          {loading ? (
            <h1>Loading</h1>
          ) : (
            <ul className="job-listings mb-5">
              {Jobs?.slice(
                (currentPage - 1) * jobsPerPage,
                currentPage * jobsPerPage
              )?.map((job, i) => {
                return (
                  <Link to={`/jobSingle/${job._id}`}
                  style={{ textDecoration: "none" }}
                  >
                    <li
                      key={i}
                      className="job-listing d-block d-sm-flex pb-3 pb-sm-0 align-items-center"

                    >
                      <div className="job-listing-logo">
                        <img
                          src={jobLogo1}
                          alt="Free Website Template by Free-Template.co"
                          className="img-fluid"
                        />
                      </div>

                      <div className="job-listing-about d-sm-flex custom-width w-100 justify-content-between mx-4">
                        <div className="job-listing-position custom-width w-50 mb-3 mb-sm-0">
                          <h2>{job?.position}</h2>
                          <strong>{job?.company.name}</strong>
                        </div>
                        <div className="job-listing-location mb-3 mb-sm-0 custom-width w-25">
                          <span className="icon-room"></span>
                          {job?.jobLocation}
                        </div>
                        <div className="job-listing-meta">
                          <span className="badge badge-danger">
                            {job?.jobType}
                          </span>
                        </div>
                      </div>
                    </li>
                  </Link>
                );
              })}
            </ul>
          )}

          <div className="row pagination-wrap">
            <div className="col-md-6 text-center text-md-left mb-4 mb-md-0"></div>
            <div className="col-md-6 text-center text-md-right">
              <div className="custom-pagination ml-auto">
                <a
                  href="#"
                  className="prev"
                  onClick={(e) => {
                    e.preventDefault();
                    handleClick(currentPage - 1);
                  }}
                  disabled={currentPage === 1}
                >
                  Prev
                </a>
                <div className="d-inline-block">
                  {pageNumbers.map((pageNumber) => (
                    <a
                      key={pageNumber}
                      href="#"
                      className={pageNumber === currentPage ? "active" : ""}
                      onClick={(e) => {
                        e.preventDefault();
                        handleClick(pageNumber);
                      }}
                    >
                      {pageNumber}
                    </a>
                  ))}
                </div>
                <a
                  href="#"
                  className="next"
                  onClick={(e) => {
                    e.preventDefault();
                    handleClick(currentPage + 1);
                  }}
                  disabled={currentPage === totalPages}
                >
                  Next
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default JobListing;
